import { render, staticRenderFns } from "./DetailVendor.vue?vue&type=template&id=023465e0&scoped=true&"
import script from "./DetailVendor.vue?vue&type=script&lang=js&"
export * from "./DetailVendor.vue?vue&type=script&lang=js&"
import style0 from "./DetailVendor.vue?vue&type=style&index=0&id=023465e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023465e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
